import { css } from '@emotion/react'
import { BasePagination } from '@/components/pagination/BasePagination'
import { PaginationInfo } from '@/components/pagination/PaginationInfo'
import { PerPageSelector } from '@/components/pagination/PerPageSelector'

interface Props {
  currentPage: number
  lastPage: number
  from: number
  to: number
  total: number
  perPage: number
  onPageChange: (page: number) => void
  onPerPageChange: (perPage: number) => void
}

const containerStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`

const leftStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ListPagination = ({
  currentPage,
  lastPage,
  from,
  to,
  total,
  perPage,
  onPageChange,
  onPerPageChange,
}: Props) => {
  return (
    <div css={containerStyle}>
      <div css={leftStyle}>
        <PaginationInfo from={from} to={to} total={total} />
        <PerPageSelector value={perPage} onChange={onPerPageChange} />
      </div>
      <BasePagination
        currentPage={currentPage}
        lastPage={lastPage}
        onPageChange={onPageChange}
      />
    </div>
  )
}
